import type { IntendedDisplay } from '@iheartjane/dm-sdk';
import { EventNames } from '@iheartjane/tracking';

import type { WebCustomImageAdEvent } from './webCustomImageAd.types';

/** What the host knows about where the ad rendered */
export interface ImageAdTrackingContext {
  adPosition: number;
  brandName: string;
  intendedDisplay: `${IntendedDisplay}`;
  menuType: 'boost' | 'premium';
  storeHasBanners: boolean;
  storeId: number | string | undefined;
}

export const imageAdTrackingPayload = (
  event: WebCustomImageAdEvent,
  context: ImageAdTrackingContext
) => {
  const common = {
    ...context,
    pathname: window.location.pathname,
    viewportWidth: window.innerWidth,
  };

  switch (event.type) {
    case 'viewed_ad':
      return { ...common, event: EventNames.ViewedImageAd as const };
    case 'clicked_ad':
      return {
        ...common,
        event: EventNames.ClickedImageAd as const,
        target: event.target,
      };
    case 'clicked_product':
      return {
        ...common,
        event: EventNames.ClickedImageAdProduct as const,
        position: event.position,
        productId: event.product.product_id,
        productName: event.product.name,
      };
    case 'swiped_products':
      return {
        ...common,
        event: EventNames.SwipedImageAdProducts as const,
        furthestPosition: event.furthestPosition,
        productCount: event.productCount,
      };
  }
};

export type ImageAdTrackingPayload = ReturnType<typeof imageAdTrackingPayload>;
